export enum BooleanEnum {
    TRUE = 'TRUE',
    FALSE = 'FALSE'
}

export const booleanEnumDisplay = {
    [BooleanEnum.TRUE]: 'True',
    [BooleanEnum.FALSE]: 'False'
};
